import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Category = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get('https://backend.hira-tech.co.uk/product/api/categories/')
      .then(response => {
        setCategories(response.data);
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
      });
  }, []);

  const printLabel = (name) => {
    const labelWindow = window.open('', '_blank', 'width=900,height=900');
    const labelStyle = `
      <style>
        @media print {
          @page {
            size: 40mm 8mm;
            margin: 0;
          }
          body {
            margin: 0;
            font-size: 12px;
            font-family: Arial, sans-serif;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 8mm;
          }
        }
        body {
          font-size: 12px;
          font-family: Arial, sans-serif;
        }
      </style>
    `;
    labelWindow.document.write(`
      <html>
        <head><title>Print Label</title>${labelStyle}</head>
        <body>${name}</body>
      </html>
    `);
    labelWindow.document.close();
    labelWindow.focus();
    labelWindow.print();
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Categories</h2>
      <div style={styles.grid}>
        {categories.map((cat) => (
          <div key={cat.catrgort_id} style={cardStyle}>
            <img src={cat.image} alt={cat.category_Name} style={styles.image} />
            <div style={styles.name}>{cat.category_Name}</div>
            <button onClick={() => printLabel(cat.category_Name)} style={buttonStyle}>
              Print Label
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem',
    fontFamily: 'Segoe UI, sans-serif',
    backgroundColor: '#f9f9f9',
  },
  heading: {
    fontSize: '24px',
    marginBottom: '1.5rem',
    color: '#333',
    textAlign: 'center',
  },
  grid: {
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  card: {
    width: '400px',
    padding: '1.5rem',
    borderRadius: '15px',
    textAlign: 'center',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
    background: 'linear-gradient(135deg, #ffffff, #f0f4f8)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  image: {
    width: '60%',
    height: '200px',
    objectFit: 'cover',
    borderRadius: '10px',
    border: '2px solid #e0e0e0',
  },
  name: {
    marginTop: '12px',
    fontWeight: '600',
    fontSize: '18px',
    color: '#2c3e50',
  },
  button: {
    marginTop: '15px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    background: '#004aad',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    transition: 'background 0.3s ease',
  },
};

const cardStyle = {
  ...styles.card,
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 12px 25px rgba(0, 0, 0, 0.2)',
  },
};

const buttonStyle = {
  ...styles.button,
  '&:hover': {
    background: 'linear-gradient(90deg, #45a049, #388e3c)',
  },
};

export default Category;